module.exports = __webpack_public_path__ + "img/antincendio.4deba98a.jpg";